import { PlanSection } from "./PlanSection";
import { CreditsSection } from "./CreditsSection";
import { PaymentHistorySection } from "./paymentHistory";
import type { MembershipData } from "../../types/membership";

interface MembershipDashboardProps {
  data: MembershipData;
}

export function MembershipDashboard({ data }: MembershipDashboardProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 space-y-8">
        <PlanSection plan={data.active_membership} />
        <PaymentHistorySection payments={data.payments} />
      </div>

      <div className="lg:col-span-1">
        <CreditsSection credits={data.details} />
      </div>
    </div>
  );
}
